/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import ko from "knockout";
import _ from "underscore";
import validate from "../util/validate.js";

var program = {
	code: "bittern",
	name: "Bittern Project",
	description: "The Bittern project aims to help ensure the long-term survival of bitterns as well as other species which inhabit the freshwater wetlands.",
	load: function() {
		return birdata.lookup().then(function(lookups) {
			program.options = {
				search_intensity: lookups.search_intensity,
				playback_status: lookups.playback_status,
				cloud_cover: lookups.cloud_cover,
				wind_speed: lookups.wind_speed,
				vegetation_type: lookups.vegetation_type,
				vegetation_size: lookups.bittern_vegetation_size
			};
			return true;
		});
	},
	fields: function() {
		return {
			searchIntensity: ko.observable(null),
			playbackStatus: ko.observable(program.options.playback_status[0]),
			flushedDistanceInMetres: ko.observable(0),
			cloudCover: ko.observable(null),
			windSpeed: ko.observable(null),
			vegetationType: ko.observable(null),
			vegetationSize: ko.observable(null)
		};
	},
	programData: function(survey) {
		return {
			fields: program.fields(),
			options: program.options
		};
	},
	updateSurveyJSON: function(json, survey) {
		function code(f) {
			return f == null ? null : f.code;
		}

		var fields = survey.programData().bittern.fields;

		json.bittern = {
			search_intensity: code(fields.searchIntensity()),
			playback_status: code(fields.playbackStatus()),
			flushed_distance_in_metres: +fields.flushedDistanceInMetres(),
			cloud_cover: code(fields.cloudCover()),
			wind_speed: code(fields.windSpeed()),
			vegetation_type: code(fields.vegetationType()),
			vegetation_size: code(fields.vegetationSize())
		};
	},
	loadFromJSON: function(json, fields, survey) {
		var options = this.options;
		var data = json.bittern;

		if(!data) return; //incomplete survey

		function lookup(items, code) {
			return _.findWhere(items, {code: code});
		}

		function l(key) {
			return lookup(options[key], data[key]);
		}

		fields.searchIntensity(l('search_intensity'));
		fields.playbackStatus(l('playback_status'));
		fields.flushedDistanceInMetres(data.flushed_distance_in_metres);
		fields.cloudCover(l('cloud_cover'));
		fields.windSpeed(l('wind_speed'));
		fields.vegetationType(l('vegetation_type'));
		fields.vegetationSize(l('vegetation_size'));
	},
	validations: function(fields, survey) {
		return [
			validate(fields.playbackStatus, function(val) {
				if(val == null) {
					return {
						full: "Playback status must be specified",
						brief: "This field is required"
					};
				}
			})
		];
	},
	visibleSharedSiteLayers: () => ["bittern"]
};

export default program;
